import React from 'react';
export function EagleSection() {
  return <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden mb-12 transition-shadow hover:shadow-lg" data-id="element-1260">
      <div className="flex flex-col md:flex-row" data-id="element-1261">
        <div className="md:w-5/12 p-8 flex items-center justify-center bg-gray-50 border-b md:border-b-0 md:border-r border-gray-100" data-id="element-1262">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20Eagle.png" alt="EAGLE" className="block max-w-full h-auto object-contain max-h-[300px]" data-id="element-1263" />
        </div>
        <div className="md:w-7/12 p-8 flex flex-col" data-id="element-1264">
          <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-tight mb-2" data-id="element-1265">
            EAGLE
          </h3>
          <h4 className="text-lg font-semibold text-navy mb-4 leading-snug" data-id="element-1266">
            High Dynamic 5-Axis Vertical Gantry Machining Center with Modular
            Structure
          </h4>
          <div className="text-gray-700 mb-6 flex-grow space-y-4" data-id="element-1267">
            <p className="leading-relaxed" data-id="element-1268">
              The wide range of structural combinations available makes it
              possible to create a bespoke configuration based on the required
              production volumes. The technical features make the machine ideal
              for{' '}
              <strong data-id="element-1269">
                high-speed machining of parts with complex 3D shapes in
                lightweight alloy, resin, or composite materials.
              </strong>
            </p>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 text-sm" data-id="element-1270">
              <div className="grid sm:grid-cols-2 gap-4 mb-3" data-id="element-1271">
                <div data-id="element-1272">
                  <strong className="text-navy block mb-1 text-xs" data-id="element-1273">
                    Eagle 1000 K 20/30/45/60/80/105/120*
                  </strong>
                  <p className="text-xs" data-id="element-1274">
                    X: 79 - 118 - 177 - 236 - 315 - 413 - 472 in.
                    <br data-id="element-1275" />
                    Y: 98 - 115 in.
                    <br data-id="element-1276" />
                    Z: 39 in.
                  </p>
                </div>
                <div data-id="element-1277">
                  <strong className="text-navy block mb-1 text-xs" data-id="element-1278">
                    Eagle 1500 K 20/30/45/60/80/105/120*
                  </strong>
                  <p className="text-xs" data-id="element-1279">
                    X: 79 - 118 - 177 - 236 - 315 - 413 - 472 in.
                    <br data-id="element-1280" />
                    Y: 98 - 115 in.
                    <br data-id="element-1281" />
                    Z: 59 in.
                  </p>
                </div>
                <div data-id="element-1282">
                  <strong className="text-navy block mb-1 text-xs" data-id="element-1283">
                    Eagle 2000 K 20/30/45/60/80/105/120*
                  </strong>
                  <p className="text-xs" data-id="element-1284">
                    X: 79 - 118 - 177 - 236 - 315 - 413 - 472 in.
                    <br data-id="element-1285" />
                    Y: 98 - 115 in.
                    <br data-id="element-1286" />
                    Z: 79 in.
                  </p>
                </div>
                <div data-id="element-1287">
                  <strong className="text-navy block mb-1 text-xs" data-id="element-1288">
                    Eagle 2500 K 20/30/45/60/80/105/120*
                  </strong>
                  <p className="text-xs" data-id="element-1289">
                    X: 79 - 118 - 177 - 236 - 315 - 413 - 472 in.
                    <br data-id="element-1290" />
                    Y: 98 - 115 in.
                    <br data-id="element-1291" />
                    Z: 98 in.
                  </p>
                </div>
              </div>
              <p className="text-xs italic text-gray-500" data-id="element-1292">
                *X-stroke available every 2 meters up to 30 meters
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-auto pt-4 border-t border-gray-100" data-id="element-1293">
            <a href="https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=Breton%20Eagle" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1294">
              <span className="mr-2" data-id="element-1295">+</span> Request Quote
            </a>
            <a href="https://www.breton.it/products/machines-and-lines/eagle" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1296">
              <span className="mr-2" data-id="element-1297">+</span> Additional Information
            </a>
          </div>
        </div>
      </div>
    </div>;
}